import PropTypes from 'prop-types';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';

import { convertDuration } from 'utils/convertDuration';
import Img from 'retired/Img';
import ArrowRightIcon from 'assets/icons/arrow-right.svg';
import { blackish } from 'utils/color-styles';
import getDeedPathSlugFromType from 'utils/getDeedPathSlugFromType';
import VolunteerTimeOff from 'entities/volunteerTimeOff/model';
import Status from 'retired/Status';
import { DeedListDateInfoWithStatus } from 'components/DeedListDateInfoWithStatus';
import { deedStyles } from 'containers/VolunteerPage/deedStyles';

import { VOLUNTEER_TIME_APPROVAL, VOLUNTEER_TIME_OFF_STATUSES } from './constants';

const VolunteerHoursAndTimeOff = ({ volunteerTime }) => {
  const isVto = volunteerTime instanceof VolunteerTimeOff;
  const date = isVto ? volunteerTime.startingAt : volunteerTime.date;
  const volunteerTimeContent = (
    <div style={{ ...deedStyles, opacity: volunteerTime.approval === 'Rejected' ? 0.4 : 1 }}>
      <DeedListDateInfoWithStatus date={date}></DeedListDateInfoWithStatus>
      <div style={{ flexGrow: 1, marginLeft: 28 }}>
        <Grid container alignItems="center">
          <Grid item xs style={{ height: '100%', margin: '0 !important' }}>
            <h3
              style={{
                fontSize: 16,
                fontWeight: 500,
                margin: '0px 0px 7px',
              }}
            >
              {volunteerTime.deed?.name ||
                `External volunteering${
                  volunteerTime.nonprofit?.name || volunteerTime.externalNonprofitName
                    ? ` for ${volunteerTime.nonprofit?.name || volunteerTime.externalNonprofitName}`
                    : ''
                }`}
            </h3>
            <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
              <>
                <span style={{ fontWeight: 500 }}>{convertDuration(volunteerTime.duration)}</span>
                {isVto ? <>&nbsp;VTO</> : null}
              </>
              {isVto ? (
                <Status
                  title={VOLUNTEER_TIME_OFF_STATUSES[volunteerTime.status].name}
                  icon={VOLUNTEER_TIME_OFF_STATUSES[volunteerTime.status].icon}
                  textColor={VOLUNTEER_TIME_OFF_STATUSES[volunteerTime.status].textColor}
                  color={VOLUNTEER_TIME_OFF_STATUSES[volunteerTime.status].chipColor}
                  style={{ marginLeft: 10 }}
                />
              ) : (
                <Status
                  title={VOLUNTEER_TIME_APPROVAL[volunteerTime.approval].name}
                  icon={VOLUNTEER_TIME_APPROVAL[volunteerTime.approval].icon}
                  textColor={VOLUNTEER_TIME_APPROVAL[volunteerTime.approval].textColor}
                  color={VOLUNTEER_TIME_APPROVAL[volunteerTime.approval].chipColor}
                  style={{ marginLeft: 10 }}
                />
              )}
            </div>
          </Grid>
          <Grid item xs>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                height: 93,
                paddingTop: 5,
                overflow: 'hidden',
                alignItems: 'flex-end',
              }}
            />
          </Grid>
        </Grid>
      </div>
      {!!volunteerTime.deed && (
        <div style={{ lineHeight: '100px' }}>
          <Img
            src={ArrowRightIcon}
            alt=""
            style={{
              height: 24,
              verticalAlign: 'middle',
              marginLeft: 38,
              marginRight: 38,
            }}
          />
        </div>
      )}
    </div>
  );
  return volunteerTime.deed ? (
    <Link
      style={{ color: blackish }}
      to={`/deeds/${getDeedPathSlugFromType(volunteerTime.deed.type)}/${volunteerTime.deed.id}`}
    >
      {volunteerTimeContent}
    </Link>
  ) : (
    volunteerTimeContent
  );
};
VolunteerHoursAndTimeOff.propTypes = {
  volunteerTime: PropTypes.object.isRequired,
};

export default VolunteerHoursAndTimeOff;
